import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FontDownloadOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"font_download_off"}/>
}
